import { render } from "./AccountCreate.vue?vue&type=template&id=c7030fb0&ts=true"
import script from "./AccountCreate.vue?vue&type=script&lang=ts"
export * from "./AccountCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__